import { z } from "zod";

import { jsonHeaders } from "@/packages/dashboard/csrf";
import { withAppDomain } from "@/packages/dashboard/utils/url-utils";

const deleteMealItemResponseSchema = z.object({
  meal_item: z.object({
    id: z.number().int().positive(),
  }),
});

export type DeleteMealItemResponse = z.infer<typeof deleteMealItemResponseSchema>;

export async function deleteMealItem(mealItemId: number): Promise<DeleteMealItemResponse> {
  if (!Number.isFinite(mealItemId) || mealItemId <= 0) {
    throw new Error("A valid meal item identifier is required to delete a meal item");
  }

  const response = await fetch(withAppDomain(`/api/v1/meals/meal_items/${mealItemId}`), {
    method: "DELETE",
    headers: jsonHeaders(),
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(`Meal item delete failed (${response.status}): ${errorBody}`);
  }

  const data = await response.json();
  return deleteMealItemResponseSchema.parse(data);
}
